import React from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '@src/languages';
import CreditsIcon from '@src/assets/icons/credits-icon.svg';
import { COLOR } from '@src/styles/color';
import SubjectRoundedIcon from '@mui/icons-material/SubjectRounded';
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import { SERVICE_TYPE } from '@src/constants/apiApp';
import SummaryCard from '../EarningsManagement/Summary/SummaryCard';
import { StyledSummary } from './index.style';
import SummaryTitle from './SummaryTitle';

const Summary = ({
  statistics,
  selectedDate,
  handleDateRangeChange,
  handleResetFilter,
  loading,
  isNewUIAppDetail,
  activeServiceTab,
  onTabChange,
}) => {
  const { t } = useTranslation();
  const { language } = i18n;

  const {
    totalRequests = 0,
    failureRequests = 0,
    totalCharacters = 0,
    totalCredits = 0,
    totalDuration = 0,
  } = statistics || {};

  const isSTTActive = isNewUIAppDetail && activeServiceTab === SERVICE_TYPE.STT;

  const cardsData = [
    {
      title: t('totalRequest'),
      value: `${totalRequests?.toLocaleString(language)}`,
      icon: (
        <MenuRoundedIcon sx={{ fontSize: '24px', color: COLOR.navyBlue }} />
      ),
      show: true,
    },
    {
      title: t('errorPercent'),
      value: `${
        totalRequests
          ? parseFloat((failureRequests / totalRequests) * 100)
              .toFixed(2)
              ?.toLocaleString(language)
          : 0?.toLocaleString(language)
      }`,
      icon: (
        <ReportProblemRoundedIcon
          sx={{ fontSize: '24px', color: COLOR.navyBlue }}
        />
      ),
      showUnit: true,
      appDetail: true,
      show: true,
    },
    isSTTActive
      ? {
          title: t('totalDurationAppDetail'),
          value: `${totalDuration?.toLocaleString(language)} ${t('seconds')}`,
          icon: (
            <AccessTimeRoundedIcon
              sx={{ fontSize: '24px', color: COLOR.navyBlue }}
            />
          ),
          show: true,
        }
      : {
          title: t('totalChars'),
          value: `${totalCharacters?.toLocaleString(language)}`,
          icon: (
            <SubjectRoundedIcon
              sx={{ fontSize: '24px', color: COLOR.navyBlue }}
            />
          ),
          show: true,
        },
    {
      title: t('totalCreditsDetailApp'),
      value: `${totalCredits?.toLocaleString(language)}`,
      icon: (
        <img
          src={CreditsIcon}
          alt="Credits"
          style={{ width: '24px', height: '24px' }}
        />
      ),
      show: true,
    },
  ];
  return (
    <>
      <SummaryTitle
        selectedDate={selectedDate}
        handleDateRangeChange={handleDateRangeChange}
        handleResetFilter={handleResetFilter}
        isNewUIAppDetail={isNewUIAppDetail}
        activeServiceTab={activeServiceTab}
        onTabChange={onTabChange}
      />
      <StyledSummary>
        {cardsData
          ?.filter((card) => card.show)
          .map((card) => (
            <SummaryCard key={card.title} {...card} loading={loading} />
          ))}
      </StyledSummary>
    </>
  );
};

export default Summary;
